import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import SectionChart from '../shared/sectionChart/SectionChart';
import SectionHero from '../shared/sectionHero/SectionHero';
import MostOfferedPerks from './charts/MostOfferedPerks';
import MostWantedRoles from './charts/MostWantedRoles';
import SalaryOfferedVsWanted from './charts/SalaryOfferedVsWanted';
import { HERODATA } from './Companies.constants';
import { StyledSection } from './Companies.styled';
import LocationOffered from './LocationOffered';

const Companies: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');
  const heroData = HERODATA(t);

  return (
    <StyledSection>
      <SectionHero
        background={getPublicPath(
          '/images/stateSector/2023/companies-hero-bg.webp'
        )}
        backgroundSm={getPublicPath(
          '/images/stateSector/2023/companies-hero-bg-sm.webp'
        )}
        title={t('mandecar23.companies.hero.title')}
        desc={t('mandecar23.companies.hero.desc')}
        data={heroData}
      />
      <SectionChart
        title={t('mandecar23.companies.salary-offered-wanted.title')}
        desc={t('mandecar23.companies.salary-offered-wanted.desc')}
        descExtra={t('mandecar23.companies.salary-offered-wanted.descExtra')}
      >
        <SalaryOfferedVsWanted />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.companies.most-wanted-roles.title')}
        desc={t('mandecar23.companies.most-wanted-roles.desc')}
        descExtra={t('mandecar23.companies.most-wanted-roles.descExtra')}
      >
        <MostWantedRoles />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.companies.most-offered-perks.title')}
        desc={t('mandecar23.companies.most-offered-perks.desc')}
        descExtra={t('mandecar23.companies.most-offered-perks.descExtra')}
      >
        <MostOfferedPerks />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.companies.locations-offered.title')}
        desc={t('mandecar23.companies.locations-offered.desc')}
      >
        <LocationOffered />
      </SectionChart>
    </StyledSection>
  );
};

export default Companies;
